import { render, staticRenderFns } from "./TypeFilePDFIcon.vue?vue&type=template&id=7b5814b7&"
import script from "./TypeFilePDFIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFilePDFIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports